<template>
  <el-header class="page-header"
    :height="headerHeight"
    :class="{ 'default-theme': isDefaultTheme, 'white-theme': isWhiteTheme, 'red-theme':  isRedTheme}">
    <div class="page-header__left">
      <slot name="logo"></slot>
    </div>
    <div class="page-header-right-wrap">
      <div class="full-screen-area" @click="toggleFullScreen">
        <template v-if="isWhiteTheme">
          <div v-show="!isFullScreen">
            <img src="./svgs/fullscrrrn_white.svg" alt="展开">
          </div>
          <div v-show="isFullScreen">
            <img src="./svgs/shrink_white.svg" alt="收起">
          </div>
        </template>
        <template v-if="isDefaultTheme">
          <div v-show="!isFullScreen">
            <img src="./svgs/fullscrrrn.svg" alt="展开">
          </div>
          <div v-show="isFullScreen">
            <img src="./svgs/shrink.svg" alt="收起">
          </div>
        </template>
      </div>
      <el-dropdown trigger="click">
        <div class="person-info-area">
          <div class="avatar-icon">
            <span>{{ lastTwoText }}</span>
          </div>
          <div class="page-header__right" v-if="accountInfo.account">
            <div class="account">
              <div class="account-info-name">{{ accountInfo.name }}</div>
              <div class="account-info-code">
                <span class="left-text">{{ accountInfo.account }}</span>
                <img v-if="isWhiteTheme"  src="./svgs/title_theme-dark-blue_arror.svg" alt="展开">
                <img v-if="isDefaultTheme" src="./svgs/title_theme-white_arrow.svg" alt="展开">
              </div>
            </div>
          </div>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click.native="doLoginOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script lang="ts" setup>
import {computed} from 'vue'
import privateCapabilities from '@cttq/private-capabilities-v3';
import {fullScreenHook} from './fullScreen'
import {loginOut} from './logout'

interface Props {
  themeType?: string;
  headerHeight?: string;
}
const props = withDefaults(defineProps<Props>(), {
  themeType: 'default',
  headerHeight: '50px'
})

const emit = defineEmits(['toggleFullScreen', 'loginOut', 'toggle-fullscreen'])  

const globalStateAll = privateCapabilities.userGlobalState()

const globalState = globalStateAll.state


const isWhiteTheme = computed(() => {
  return props.themeType === 'white'
})
const isDefaultTheme = computed(() => {
  return props.themeType === 'default'
})
const isRedTheme = computed(() => {
  return props.themeType === 'red'
})
const accountInfo = computed(() => {
  if (globalState && globalState.userInfo && globalState.userInfo.personName) {
    const name = globalState.userInfo.personName;
    // 统一认证取personCode，其他取account
    const account = globalState.userInfo.personCode;
    return {
      name,
      account
    };
  }
 return {}
})
const lastTwoText = computed(() => {
  // 截取 this.accountInfo.name 的后两位
  return accountInfo.value.name ? accountInfo.value.name.slice(-2) : ''
})

const {isFullScreen,toggleFullScreen} = fullScreenHook(emit)

const doLoginOut = () => {
  loginOut(() => {
    emit('loginOut')
  })
}

defineOptions({
  name: "TqPageHeader",
});

</script>
